export default "__VITE_ASSET__EhyL9wHR__"